import React from "react";
import { IFiller } from "../../types/filler.type";
import { Spin, Table } from "antd";

interface FillersInOrderProps {
  data: IFiller[] | null;
  loading: boolean;
}

export default function FillersInOrder({ data, loading }: FillersInOrderProps) {
  if (loading) {
    return <Spin size="large" />;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  const columns = [
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Кол-во",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Обновлен",
      dataIndex: "lastUpdate",
      key: "lastUpdate",
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ textAlign: "center" }}>Филлеры со статусом Заказ</h2>

      <div style={{ marginTop: "20px", maxHeight: "300px", overflowY: "auto" }}>
        <Table
          dataSource={data}
          columns={columns}
          rowKey={(record) => record._id}
          pagination={false}
          scroll={{ y: 240, x: "max-content" }}
        />
      </div>
    </div>
  );
}
